const allaccreceivableagingdetail = { data: [], loading: true };
export const GetAllAccReceivableAgingDetail = (state = allaccreceivableagingdetail, action) => {
  switch (action.type) {
    case "get_allaccreceivableagingdetail":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
